import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReportTable from "../../../components/report/report-table";
import ScoreView from "../../../components/UI/ScoreView";
import * as configActions from "../../../store/config/actions";
import { useDispatch } from "react-redux";
import Notation from "../../../components/report/notation";
import { handleCompPerformance } from "../../../helpers";
import SubjectwiseReport from "./SubjectwiseReport";
import { textIdentifier } from "../../../textIdentifier";


export default function SubTopicClassReport() {
  const { selectedCompetition, selectedSchool, selectedClass,lang } = useSelector(
    (state) => state.main
  );
  const navigate = useNavigate();
  const [values, setValues] = useState([]);
  const [isFetching, setIsFetching] = useState(true);
  const dispatch = useDispatch();

  const fetchData = async () => {
    try {
      // filtering data
      const vals = selectedClass.subTopicData.map((item) => {
        const { accuracy, proficiency, marks } = item;

        const competition = selectedCompetition.subTopicsWiseReportData.find(
          (data) => data.id === item.id
        );
        const school = selectedSchool.subTopicData.find(
          (data) => data.id === item.id
        );

        let class_proficiency_status = handleCompPerformance(
          proficiency,
          school.proficiency
        );
        let school_proficiency_status = handleCompPerformance(
          proficiency,
          competition.proficiency
        );

        let class_accuracy_status = handleCompPerformance(
          accuracy,
          school.accuracy
        );
        let school_accuracy_status = handleCompPerformance(
          accuracy,
          competition.accuracy
        );
        let class_marks_status = handleCompPerformance(marks, school.marks);
        let school_marks_status = handleCompPerformance(
          marks,
          competition.marks
        );
        const val = Object.assign(item, {
          class_proficiency_status,
          school_proficiency_status,
          class_accuracy_status,
          school_accuracy_status,
          class_marks_status,
          school_marks_status,
          overall_competition_proficiency: competition.proficiency,
          overall_school_proficiency: school.proficiency,
          overall_competition_accuracy: competition.accuracy,
          overall_school_accuracy: school.accuracy,
          overall_competition_marks: competition.marks,
          overall_school_marks: school.marks,
        });

        return val;
      });

      setValues(vals);
    } catch (error) {
      dispatch(configActions.showAlert(error.message));
    } finally {
      setIsFetching(false);
    }
  };

  const handleFloatParse = (val) => {
    return parseFloat(val).toFixed(2);
  };

  const competition_proficiency_status = (value, comp_proficiency) => (
    <ScoreView
      content={textIdentifier["overall-proficiency"][lang]+` ${parseFloat(comp_proficiency).toFixed(
        2
      )}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const school_proficiency_status = (value, school_proficiency) => (
    <ScoreView
      content={textIdentifier["school-proficiency"][lang]+` ${parseFloat(school_proficiency).toFixed(
        2
      )}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const competition_accuracy_status = (value, comp_accuracy) => (
    <ScoreView
      content={textIdentifier["overall-accuracy"][lang]+` ${parseFloat(comp_accuracy).toFixed(2)}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const school_accuracy_status = (value, school_accuracy) => (
    <ScoreView
      content={textIdentifier["school-accuracy"][lang]+` ${parseFloat(school_accuracy).toFixed(2)}%`}
    >
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const competition_marks_status = (value, comp_marks) => (
    <ScoreView content={textIdentifier["overall-marks"][lang]+` ${parseFloat(comp_marks).toFixed(2)}`}>
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  const school_marks_status = (value, school_marks) => (
    <ScoreView content={textIdentifier["school-marks"][lang]+` ${parseFloat(school_marks).toFixed(2)}`}>
      <div>
        <Notation status={value} />
      </div>
    </ScoreView>
  );

  useEffect(() => {
    if (!selectedCompetition || !selectedSchool || !selectedClass) {
      navigate("/");
    } else {
      fetchData();
    }
  }, []);

  if (values.length === 0 && !isFetching) {
    return <p>{textIdentifier["no-data-found"][lang]}</p>;
  }

  return (
    <div className="cr-card sub-topic-wise-report">
      {/* Changes goes here for Class subjectwise report */}
      {
        !!values
        &&
        <SubjectwiseReport data={values} />
      }
      {/* {values.map((_, i) => (
        <div key={i} className="col">
          <h4>
            {i + 1}. {_.name}
          </h4>
          <ReportTable
            data={[
              [
                `${_.proficiency}%`,
                `${_.accuracy}%`,
                handleFloatParse(
                  _.easy_question_count +
                    _.medium_question_count +
                    _.hard_question_count
                ),
                handleFloatParse(_.marks),
              ],
              [
                <div className="flex-center">
                  {competition_proficiency_status(
                    _.school_proficiency_status,
                    _.overall_competition_proficiency
                  )}
                  {school_proficiency_status(
                    _.class_proficiency_status,
                    _.overall_school_proficiency
                  )}
                </div>,
                <div className="flex-center">
                  {competition_accuracy_status(
                    _.school_accuracy_status,
                    _.overall_competition_accuracy
                  )}
                  {school_accuracy_status(
                    _.class_accuracy_status,
                    _.overall_school_accuracy
                  )}
                </div>,
                `(E${handleFloatParse(
                  _.easy_question_count
                )}, M${handleFloatParse(
                  _.medium_question_count
                )}, H${handleFloatParse(_.hard_question_count)})`,
                <div className="flex-center">
                  {competition_marks_status(
                    _.school_proficiency_status,
                    _.overall_competition_marks
                  )}
                  {school_marks_status(
                    _.class_proficiency_status,
                    _.overall_school_marks
                  )}
                </div>,
              ],
            ]}
            headers={[["Proficiency", "Accuracy", "Question Count", "Marks"]]}
          />
        </div>
      ))} */}
    </div>
  );
}
